import type { WritingExpressionItem } from '../writingExpressionBank';

/** Spanish writing scaffolds — discourse relations; shared by DELE / SIELE. */
export const SPANISH_WRITING_EXPRESSIONS: readonly WritingExpressionItem[] = [
  // introduce
  { id: 'es-introduce-1', category: 'introduce', text: 'En primer lugar,', gloss: '首先' },
  { id: 'es-introduce-2', category: 'introduce', text: 'Para empezar,', gloss: '开始时' },
  { id: 'es-introduce-3', category: 'introduce', text: 'Me gustaría tratar…', gloss: '我想讨论…' },
  { id: 'es-introduce-4', category: 'introduce', text: 'En los últimos años,', gloss: '近年来' },
  { id: 'es-introduce-5', category: 'introduce', text: 'Estimado/a señor/a:', gloss: '尊敬的先生/女士（书信开场）' },
  // continue
  { id: 'es-continue-1', category: 'continue', text: 'A continuación,', gloss: '接下来' },
  { id: 'es-continue-2', category: 'continue', text: 'En segundo lugar,', gloss: '其次' },
  { id: 'es-continue-3', category: 'continue', text: 'Por otra parte,', gloss: '另一方面' },
  { id: 'es-continue-4', category: 'continue', text: 'En este sentido,', gloss: '在这一点上' },
  // finally
  { id: 'es-finally-1', category: 'finally', text: 'Por último,', gloss: '最后' },
  { id: 'es-finally-2', category: 'finally', text: 'Para terminar,', gloss: '作为收尾' },
  { id: 'es-finally-3', category: 'finally', text: 'En última instancia,', gloss: '归根结底' },
  // cause_reason
  { id: 'es-cause-reason-1', category: 'cause_reason', text: 'Porque', gloss: '因为' },
  { id: 'es-cause-reason-2', category: 'cause_reason', text: 'Debido a', gloss: '由于' },
  { id: 'es-cause-reason-3', category: 'cause_reason', text: 'Puesto que', gloss: '既然' },
  { id: 'es-cause-reason-4', category: 'cause_reason', text: 'Dado que…', gloss: '鉴于…' },
  // cause_result
  { id: 'es-cause-result-1', category: 'cause_result', text: 'Por lo tanto,', gloss: '因此' },
  { id: 'es-cause-result-2', category: 'cause_result', text: 'En consecuencia,', gloss: '因而' },
  { id: 'es-cause-result-3', category: 'cause_result', text: 'Así pues,', gloss: '所以' },
  { id: 'es-cause-result-4', category: 'cause_result', text: 'Por esta razón,', gloss: '基于这一原因' },
  // contrast_turn
  { id: 'es-contrast-turn-1', category: 'contrast_turn', text: 'Sin embargo,', gloss: '然而' },
  { id: 'es-contrast-turn-2', category: 'contrast_turn', text: 'No obstante,', gloss: '不过' },
  { id: 'es-contrast-turn-3', category: 'contrast_turn', text: 'En cambio,', gloss: '相比之下' },
  { id: 'es-contrast-turn-4', category: 'contrast_turn', text: 'Por el contrario,', gloss: '相反' },
  // contrast_concede
  { id: 'es-contrast-concede-1', category: 'contrast_concede', text: 'Aunque', gloss: '虽然' },
  { id: 'es-contrast-concede-2', category: 'contrast_concede', text: 'A pesar de', gloss: '尽管' },
  { id: 'es-contrast-concede-3', category: 'contrast_concede', text: 'Si bien es cierto que…,', gloss: '诚然…' },
  { id: 'es-contrast-concede-4', category: 'contrast_concede', text: 'Es verdad que…, pero…', gloss: '的确…但是…' },
  // parallel_add
  { id: 'es-parallel-add-1', category: 'parallel_add', text: 'Además,', gloss: '此外' },
  { id: 'es-parallel-add-2', category: 'parallel_add', text: 'Asimismo,', gloss: '同样地' },
  { id: 'es-parallel-add-3', category: 'parallel_add', text: 'También', gloss: '也' },
  { id: 'es-parallel-add-4', category: 'parallel_add', text: 'Igualmente,', gloss: '同样' },
  // parallel_choice
  { id: 'es-parallel-choice-1', category: 'parallel_choice', text: 'O bien… o bien…', gloss: '要么…要么…' },
  { id: 'es-parallel-choice-2', category: 'parallel_choice', text: 'Alternativamente,', gloss: '或者' },
  { id: 'es-parallel-choice-3', category: 'parallel_choice', text: 'De lo contrario,', gloss: '否则' },
  // progressive
  { id: 'es-progressive-1', category: 'progressive', text: 'Es más,', gloss: '更有甚者' },
  { id: 'es-progressive-2', category: 'progressive', text: 'Más aún,', gloss: '更进一步' },
  { id: 'es-progressive-3', category: 'progressive', text: 'No solo… sino también…', gloss: '不仅…而且…' },
  // compare
  { id: 'es-compare-1', category: 'compare', text: 'Del mismo modo,', gloss: '同样地' },
  { id: 'es-compare-2', category: 'compare', text: 'Igualmente,', gloss: '类似地' },
  { id: 'es-compare-3', category: 'compare', text: 'De manera similar,', gloss: '以类似方式' },
  // juxtapose
  { id: 'es-juxtapose-1', category: 'juxtapose', text: 'A diferencia de…,', gloss: '不同于…' },
  { id: 'es-juxtapose-2', category: 'juxtapose', text: 'En contraste con…,', gloss: '与…形成对照' },
  { id: 'es-juxtapose-3', category: 'juxtapose', text: 'Por un lado…; por otro…', gloss: '一方面…另一方面…' },
  // exemplify
  { id: 'es-exemplify-1', category: 'exemplify', text: 'Por ejemplo,', gloss: '例如' },
  { id: 'es-exemplify-2', category: 'exemplify', text: 'En particular,', gloss: '特别是' },
  { id: 'es-exemplify-3', category: 'exemplify', text: 'Como', gloss: '比如' },
  { id: 'es-exemplify-4', category: 'exemplify', text: 'Para ilustrar,', gloss: '举例说明' },
  // exception
  { id: 'es-exception-1', category: 'exception', text: 'Excepto', gloss: '除…以外' },
  { id: 'es-exception-2', category: 'exception', text: 'A excepción de', gloss: '除了…' },
  { id: 'es-exception-3', category: 'exception', text: 'Salvo', gloss: '除去' },
  // emphasize
  { id: 'es-emphasize-1', category: 'emphasize', text: 'Conviene destacar que…', gloss: '值得强调的是…' },
  { id: 'es-emphasize-2', category: 'emphasize', text: 'Sobre todo,', gloss: '尤其是' },
  { id: 'es-emphasize-3', category: 'emphasize', text: 'En especial,', gloss: '特别是' },
  // condition
  { id: 'es-condition-1', category: 'condition', text: 'Si', gloss: '如果' },
  { id: 'es-condition-2', category: 'condition', text: 'Siempre que', gloss: '只要…' },
  { id: 'es-condition-3', category: 'condition', text: 'A menos que', gloss: '除非' },
  { id: 'es-condition-4', category: 'condition', text: 'En caso de que', gloss: '倘若' },
  // summarize
  { id: 'es-summarize-1', category: 'summarize', text: 'En conclusión,', gloss: '总之' },
  { id: 'es-summarize-2', category: 'summarize', text: 'En resumen,', gloss: '概括来说' },
  { id: 'es-summarize-3', category: 'summarize', text: 'Para concluir,', gloss: '作为总结' },
  { id: 'es-summarize-4', category: 'summarize', text: 'Por todas estas razones,', gloss: '基于以上理由' },
  // purpose
  { id: 'es-purpose-1', category: 'purpose', text: 'Para', gloss: '为了…' },
  { id: 'es-purpose-2', category: 'purpose', text: 'Con el fin de', gloss: '目的在于…' },
  { id: 'es-purpose-3', category: 'purpose', text: 'A fin de que', gloss: '为了使…' },
  // restate
  { id: 'es-restate-1', category: 'restate', text: 'En otras palabras,', gloss: '换言之' },
  { id: 'es-restate-2', category: 'restate', text: 'Es decir,', gloss: '也就是说' },
  { id: 'es-restate-3', category: 'restate', text: 'Dicho de otro modo,', gloss: '换种说法' },
  // temporal
  { id: 'es-temporal-1', category: 'temporal', text: 'Luego', gloss: '然后' },
  { id: 'es-temporal-2', category: 'temporal', text: 'Anteriormente,', gloss: '此前' },
  { id: 'es-temporal-3', category: 'temporal', text: 'Posteriormente,', gloss: '随后' },
  { id: 'es-temporal-4', category: 'temporal', text: 'Al mismo tiempo,', gloss: '与此同时' },
  // basis
  { id: 'es-basis-1', category: 'basis', text: 'Según', gloss: '根据…' },
  { id: 'es-basis-2', category: 'basis', text: 'De acuerdo con', gloss: '依据…' },
  { id: 'es-basis-3', category: 'basis', text: 'A la luz de', gloss: '鉴于…' },
  { id: 'es-basis-4', category: 'basis', text: 'Teniendo en cuenta…,', gloss: '考虑到…' },
];
